import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type AlertProps = {
  children: React.ReactNode;
  type?: 'success' | 'error' | 'warning' | 'warning-2';
  className?: string;
};

export default function Alert({ children, type, className }: AlertProps) {
  return (
    <div
      className={twMerge(
        clsx('rounded-md border p-2', {
          'mb-4 border-green bg-green2': type === 'success',
          'mb-4 border-none bg-base-yellow': type === 'warning',
          'rounded-sm border border-primary-100 bg-primary-5': type === 'warning-2',
        }),
        className,
      )}
    >
      {children}
    </div>
  );
}
